import { HeartHandshake, Compass, ShieldCheck, Users } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const cards = [
  {
    icon: HeartHandshake,
    title: "Reassurance",
    body: "Helping users remember who they are, where they are, and what is happening around them — with contextual reassurance during moments of confusion.",
  },
  {
    icon: Compass,
    title: "Independence",
    body: "Supporting everyday routines and enabling individuals to remain as self-sufficient as possible, without unnecessary dependence.",
  },
  {
    icon: ShieldCheck,
    title: "Safety",
    body: "Providing intelligent support during moments of distress while helping caregivers stay informed and connected.",
  },
  {
    icon: Users,
    title: "Connection",
    body: "Helping families remain emotionally connected and providing caregivers with greater confidence and peace of mind.",
  },
];

export default function WhyRomii() {
  return (
    <section className="py-24 lg:py-32 bg-[#F9FAFB]" data-testid="why-romii-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Eyebrow number="05" label="Why Romii" />
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#111827] max-w-2xl">
            Designed around <span className="font-serif-italic text-[#7F9F43]">everyday life.</span>
          </h2>
        </Reveal>

        <div className="mt-14 lg:mt-20 grid sm:grid-cols-2 gap-6 lg:gap-8">
          {cards.map((c, i) => (
            <Reveal key={c.title} delay={i * 0.08}>
              <div
                className="group h-full rounded-3xl bg-white border border-gray-100 p-8 lg:p-10 card-soft hover:-translate-y-1 transition-transform duration-500"
                data-testid={`why-card-${c.title.toLowerCase()}`}
              >
                <div className="h-12 w-12 rounded-2xl bg-[#7F9F43]/10 flex items-center justify-center text-[#7F9F43] group-hover:bg-[#7F9F43] group-hover:text-white transition-colors duration-500">
                  <c.icon size={22} strokeWidth={1.75} />
                </div>
                <h3 className="mt-6 text-lg md:text-xl font-semibold text-[#111827]">{c.title}</h3>
                <p className="mt-3 text-gray-500 leading-relaxed text-sm md:text-base">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
